import React from 'react';
import { Box, Typography, Grid, Chip, Stack } from '@mui/material';

export const PageContainer = ({ title, description, children, actions, headerSpacing = 4 }) => (
  <Box>
    <Stack
      direction={{ xs: 'column', md: 'row' }}
      spacing={2}
      justifyContent="space-between"
      alignItems={{ xs: 'flex-start', md: 'center' }}
      sx={{ mb: headerSpacing }}
    >
      <Box>
        <Typography
          variant="h4"
          sx={{
            color: 'var(--wb-text-title)',
            fontSize: { xs: '1.6rem', md: '2rem' },
            fontWeight: 600
          }}
        >
          {title}
        </Typography>
        {description && (
          <Typography sx={{ color: 'var(--wb-muted-80)', mt: 1 }}>
            {description}
          </Typography>
        )}
      </Box>
      {actions && <Stack direction="row" spacing={1}>{actions}</Stack>}
    </Stack>
    {children}
  </Box>
);

export const Section = ({ title, subtitle, chips, children }) => (
  <Box
    sx={{
      backgroundColor: 'var(--wb-bg-panel)',
      borderRadius: 2,
      border: '1px solid var(--wb-border)',
      p: { xs: 2, md: 3 },
      mb: 3,
      boxShadow: '0 12px 32px var(--wb-x-shadow-0f172a59, rgba(15, 23, 42, 0.35))'
    }}
  >
    <Box sx={{ mb: children ? 2.5 : 0 }}>
      <Typography variant="h6" sx={{ color: 'var(--wb-text)', fontWeight: 600 }}>
        {title}
      </Typography>
      {subtitle && (
        <Typography sx={{ color: 'var(--wb-muted-70)', mt: 0.5 }}>
          {subtitle}
        </Typography>
      )}
      {chips && (
        <Stack direction="row" spacing={1} sx={{ mt: 1.5 }}>
          {chips.map((label) => (
            <Chip
              key={label}
              label={label}
              size="small"
              sx={{
                backgroundColor: 'var(--wb-accent-tint)',
                color: 'var(--wb-accent)',
                fontWeight: 500
              }}
            />
          ))}
        </Stack>
      )}
    </Box>
    {children}
  </Box>
);

export const StatGrid = ({ items }) => (
  <Grid container spacing={2}>
    {items.map((item) => (
      <Grid item xs={12} sm={6} md={3} key={item.label}>
        <Box
          sx={{
            backgroundColor: 'var(--wb-bg-surface)',
            borderRadius: 2,
            border: '1px solid var(--wb-border-10)',
            p: 2.5
          }}
        >
          <Typography sx={{ color: 'var(--wb-muted-70)', fontSize: '0.85rem' }}>
            {item.label}
          </Typography>
          <Typography sx={{ color: 'var(--wb-text-title)', fontSize: '1.6rem', fontWeight: 600 }}>
            {item.value}
          </Typography>
          {item.trend && (
            <Typography sx={{ color: item.trend.startsWith('+') ? 'var(--wb-success)' : 'var(--wb-danger)', mt: 0.5 }}>
              {item.trend}
            </Typography>
          )}
        </Box>
      </Grid>
    ))}
  </Grid>
);
